import { CallStatus } from '../../models/call-status.enum';
import { DigitalPayeeEnrollmentStatus } from '../../models/digital-payee-enrollment-status.model';
import { NpoSearchResults } from '../../models/npo-search-results.model';
import { Npo } from '../../models/npo.model';

export interface DppEnrollmentState {
    npoSearchRequest: {
        ein: string;
        pageNumber: number;
    } | null;
    npoSearchResults: NpoSearchResults | null;
    selectedNpo: Npo | null;
    partnershipChanged: boolean;
    hasSecondaries: boolean;
    returnedFromStripe: boolean;
    npoSearchCallStatus: CallStatus;
    enrollmentStatusCallStatus: CallStatus;
    enrollmentStatus: DigitalPayeeEnrollmentStatus | null;
    showErrorsIfClean: boolean;
}

export const initialState: DppEnrollmentState = {
    npoSearchRequest: null,
    npoSearchResults: null,
    selectedNpo: null,
    partnershipChanged: false,
    hasSecondaries: false,
    returnedFromStripe: false,
    npoSearchCallStatus: CallStatus.INITIAL,
    enrollmentStatusCallStatus: CallStatus.INITIAL,
    enrollmentStatus: null,
    showErrorsIfClean: false,
};
